import baseUrl from "@/config/url.js";
import { systemInfo } from "@/common/index.js";
// 版本号
const versionNum = "5.4.45";
// 客户端平台
const source = systemInfo.platform;
// 分享到小程序 0正式 2体验版
let wxType = 0
// #ifdef MP-WEIXIN
if (baseUrl.indexOf('//api.bgbgsc.com') == -1) {
// #endif
// #ifndef MP-WEIXIN
if (baseUrl.indexOf('//h5.bgbgsc.com') == -1) {
// #endif	
	wxType = 2
}

const statusBarHeight = systemInfo.statusBarHeight // 手机端头部手机时间位置高度

export {
	source,
	baseUrl,
	versionNum,
	wxType,
  statusBarHeight,
};